import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { createBox } from '@famly/mf_layout_box';
import RoutesMap from 'signin-app/routes/routes-map';
import { useCustomWhitelabelColor } from 'signin-app/components/hooks/use-custom-whitelabel-color';
const StyledBox = styled(createBox({})).withConfig({
    shouldForwardProp: prop => prop !== 'customBackgroundColor',
}) `
    background-color: ${props => props.customBackgroundColor ? props.customBackgroundColor : props.theme.mf.colorPalette.n25};
    // Fallback for browsers that don't support svh unit
    min-height: 100vh;
    min-height: 100svh;
`;
export const AppContainer = ({ children }) => {
    const location = useLocation();
    const path = React.useMemo(() => {
        return location.pathname;
    }, [location.pathname]);
    const p500 = useCustomWhitelabelColor('p500');
    const backgroundColor = path === '/' || path === RoutesMap.pin || path === RoutesMap.qr ? p500 : undefined;
    return _jsx(StyledBox, { customBackgroundColor: backgroundColor, children: children });
};
